module.exports = __webpack_public_path__ + "img/butterfly.49e8070b.png";